import React from 'react';

const TOSPage: React.FC = () => {
  return (
    <div className="bg-gray-950 text-white min-h-screen py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header with PDF Download */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-white mb-4">Terms of Service</h1>
          <p className="text-xl text-gray-400 mb-8">
            Last updated: May 20, 2025
          </p>
          <a 
            href="/BarnBills LLC Terms of Service.pdf" 
            download 
            className="inline-flex items-center space-x-2 brand-gradient text-white px-6 py-3 rounded-lg font-medium transition-all duration-200 hover:shadow-lg hover:shadow-blue-500/25"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-4-4m4 4l4-4m-6 4h8"></path>
            </svg>
            <span>Download PDF Version</span>
          </a>
        </div>
        
        {/* Terms of Service Content */}
        <div className="prose prose-invert max-w-none text-gray-300">
          
          {/* 1. Acceptance of Terms */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing or using the BarnBills SaaS platform (the "Service") you agree to be bound 
              by these Terms of Service. If you do not agree, do not use the Service.
            </p>
          </section>

          {/* 2. Beta Disclaimer */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">2. Beta Disclaimer</h2>
            <p>
              The Service is BETA software provided "AS IS". Features may change without 
              notice and may contain errors. BarnBills LLC makes no warranties of any kind 
              and expressly disclaims all implied warranties, including merchantability, fitness for 
              a particular purpose, and non-infringement.
            </p>
          </section>

          {/* 3. License Grant */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">3. License Grant</h2>
            <p>
              BarnBills LLC grants you a non-exclusive, non-transferable, revocable license to access and use the Service solely for managing billing records for equine operations you 
              own or manage.
            </p>
          </section>

          {/* 4. Restrictions */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">4. Restrictions</h2>
            <p className="mb-3">You shall not:</p>
            <ol className="list-decimal ml-6 space-y-1">
              <li>reverse-engineer, decompile, or disassemble the Service;</li>
              <li>resell or sublicense the Service;</li>
              <li>use the Service to infringe the intellectual-property rights of others; or</li>
              <li>upload unlawful or harmful content.</li>
            </ol>
          </section>

          {/* 5. Account Security */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">5. Account Security</h2>
            <p>
              You are responsible for maintaining the confidentiality of your login credentials and for 
              all activities under your account. Enable multi-factor authentication where offered.
            </p>
          </section>

          {/* 6. Data Ownership */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">6. Data Ownership</h2>
            <p>
              You retain all rights to the data you upload ("Customer Data"). BarnBills may access 
              or process Customer Data only to provide and improve the Service and as otherwise 
              permitted by this Agreement.
            </p>
          </section>

          {/* 7. Support and Updates */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">7. Support and Updates</h2>
            <p>
              During the beta period support is provided on a best-effort basis via email at support@barnbills.com. BarnBills may deploy updates at any time and may suspend the 
              Service for maintenance with reasonable notice when practicable.
            </p>
          </section>

          {/* 8. Liability Cap */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">8. Liability Cap</h2>
            <p>
              To the maximum extent permitted by law, BarnBills LLC's total liability 
              for any claim arising out of or relating to the Service shall not exceed one 
              hundred U.S. dollars (US $100). In no event shall BarnBills be liable for indirect, 
              consequential, or special damages.
            </p>
          </section>

          {/* 9. Termination */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">9. Termination</h2>
            <p>
              Either party may terminate use of the Service at any time. Upon termination you 
              may request a data export; BarnBills will delete your Customer Data within 30 days 
              except where retention is required by law.
            </p>
          </section>

          {/* 10. Governing Law */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">10. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the Commonwealth of Kentucky, without 
              regard to conflict-of-laws principles.
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-gray-800 text-center">
            <p className="text-gray-500">End of Terms of Service</p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TOSPage; 